import { useCallback, useMemo } from "react";
import { Select } from "@alm/flow-ds/components";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

import api from "lib/api/api";
import addSentryBreadcrumb from "sentry/addSentryBreadcrumb";
import { languageMap } from "../../constants";

const Language = () => {
	const { t, i18n } = useTranslation();

	// Sort languages into alphabetical order
	const languages = useMemo(
		() =>
			i18next.languages.length
				? i18next.languages
						.map((language: string) => {
							const fullLanguageName = languageMap[language];
							return { fullLanguageName, language };
						})
						.sort((a, b) =>
							a.fullLanguageName.localeCompare(b.fullLanguageName)
						)
				: null,
		[]
	);

	/**
	 * Changes the language when select value is changed
	 *
	 * @param e select event object
	 */
	const handleChangeLanguage = useCallback(
		(e: React.ChangeEvent<HTMLSelectElement>) => {
			const value = e.currentTarget.value;
			addSentryBreadcrumb({
				category: "input.change",
				message: `Language value change to ${value}`,
			});

			i18n.changeLanguage(value);

			// update the Accept-Language header to the language that it has been changed to
			api.defaults.headers.common["Accept-Language"] = i18next.language;
		},
		[i18n]
	);

	return (
		<Select
			value={i18next.language}
			onChange={handleChangeLanguage}
			label={t("main.profile.language")}>
			{languages?.map(({ fullLanguageName, language }) => {
				return (
					<option value={language} key={language}>
						{fullLanguageName}
					</option>
				);
			})}
		</Select>
	);
};

export default Language;
